import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const committeeMeetingAttendancesApi = {
    getCommitteeMeetingAttendances: (committeeMeetingId: number): Observable<Dtos.GetCommitteeMeetingAttendancesResponse> => {
        //Create the request.
        let request: Dtos.GetCommitteeMeetingAttendances = new Dtos.GetCommitteeMeetingAttendances();
        request.committeeMeetingId = committeeMeetingId;

        //Send request.
        const response: Promise<Dtos.GetCommitteeMeetingAttendancesResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getCommitteeMeetingAttendanceById: (id: number): Observable<Dtos.GetCommitteeMeetingAttendanceByIdResponse> => {
        //Create the request.
        let request: Dtos.GetCommitteeMeetingAttendanceById = new Dtos.GetCommitteeMeetingAttendanceById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetCommitteeMeetingAttendanceByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getCommitteeMeetingAttendanceByCommitteeMeetingId: (committeeMeetingId: number): Observable<Dtos.GetCommitteeMeetingAttendanceByCommitteeMeetingIdResponse> => {
        //Create the request.
        let request: Dtos.GetCommitteeMeetingAttendanceByCommitteeMeetingId = new Dtos.GetCommitteeMeetingAttendanceByCommitteeMeetingId();

        request.committeeMeetingId = committeeMeetingId;

        //Send request.
        const response: Promise<Dtos.GetCommitteeMeetingAttendanceByCommitteeMeetingIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setCommitteeMeetingAttendance: (committeeMeetingAttendance: Dtos.CommitteeMeetingAttendance): Observable<Dtos.SetCommitteeMeetingAttendanceResponse> => {

        let request: Dtos.SetCommitteeMeetingAttendance = new Dtos.SetCommitteeMeetingAttendance();

        request.committeeMeetingAttendance = committeeMeetingAttendance;

        // send request
        const response: Promise<Dtos.SetCommitteeMeetingAttendanceResponse> = client.post(request);

        return Observable.from(response);
    },
    createCommitteeMeetingAttendance: (committeeMeetingId: number): Observable<Dtos.CreateCommitteeMeetingAttendanceResponse> => {
        //Create the request.
        let request: Dtos.CreateCommitteeMeetingAttendance = new Dtos.CreateCommitteeMeetingAttendance();

        request.committeeMeetingId = committeeMeetingId;

        //Send request.
        const response: Promise<Dtos.CreateCommitteeMeetingAttendanceResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateCommitteeMeetingAttendance: (committeeMeetingAttendance: Dtos.CommitteeMeetingAttendance): Observable<Dtos.ValidateCommitteeMeetingAttendanceResponse> => {

        let request: Dtos.ValidateCommitteeMeetingAttendance = new Dtos.ValidateCommitteeMeetingAttendance();

        request.committeeMeetingAttendance = committeeMeetingAttendance;

        // send request
        const response: Promise<Dtos.ValidateCommitteeMeetingAttendanceResponse> = client.post(request);

        return Observable.from(response);
    },
}